import * as square from "./square";

export interface SidesValue {
  top: string;
  right: string;
  bottom: string;
  left: string;

  linked: string;
  isLinked: boolean;
}
export const parseValue = (value: string | undefined): SidesValue => {
  const parsed = square.parseValue(value);
  return {
    top: parsed.first,
    right: parsed.second,
    bottom: parsed.third,
    left: parsed.fourth,

    isLinked: parsed.isLinked,
    linked: parsed.linked
  };
};

export const isZero = (value: string | undefined | SidesValue): boolean => {
  const parsed = typeof value === "object" ? value : parseValue(value);
  if (parsed.isLinked) return parseFloat(parsed.linked) === 0;

  return (
    parseFloat(parsed.top) === 0 &&
    parseFloat(parsed.right) === 0 &&
    parseFloat(parsed.bottom) === 0 &&
    parseFloat(parsed.left) === 0
  );
};
